module.exports = __webpack_public_path__ + "static/media/clientFour.e889556f.webp";